/**
 * axios异常的类型守卫
 * @param error
 * @returns
 */
export function isAxiosError(error) {
    return error.isAxiosError === true;
}
/**
 * request异常的类型守卫
 * @param error
 * @returns
 */
export function isRequestError(error) {
    return error.isRequestError === true;
}
/**
 * 增强异常
 * @param error 原始Error实例
 * @param type 异常类型
 * @param config 请求配置信息
 * @param code 错误码 （http异常 则表示http status 业务异常 则表示业务错误码）
 * @returns
 */
export var enhanceRequestError = function (error, type, config, options) {
    if (options === void 0) { options = {}; }
    var requestError = error;
    requestError.isRequestError = true;
    requestError.type = type;
    requestError.config = config;
    var code = options.code, source = options.source;
    if (code) {
        requestError.code = code;
    }
    if (source) {
        requestError.source = source;
    }
    return requestError;
};
/**
 * 创建异常
 * @param message 异常描述
 * @param type 异常类型
 * @param config 请求配置信息
 * @param code 错误码
 * @returns
 */
export var createRequestError = function (message, type, config, options) {
    if (options === void 0) { options = {}; }
    var error = new Error(message);
    return enhanceRequestError(error, type, config, options);
};
